import { configureStore } from "@reduxjs/toolkit";
import journeyReducer from "./journeySlice";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import { getStoredApplicationNumber, getStoredCaseId } from "../common/utils";
import { combineReducers } from "redux";

const journeyInitialState = {
  currentStage: "lead",
  applicationNumber: getStoredApplicationNumber() || null,
  apiCache: {},
  journeyData: null,
  caseId: getStoredCaseId() || null,
  leadResult: null,
  quoteInitResult: null,
  quoteResult: null,
  premiumResult: null,
  premiumLoading: false,
  premiumLoadingCount: 0,
  premiumError: null,
  leadFormData: null,
  multiDimensionPremiumResult: null,
  multiDimensionByPlan: null,
  quoteRiders: { selectedIds: [], covers: {} },
  quoteOptions: {
    premiumRefundEnabled: false,
    enhancedCoverageEnabled: false,
  },
  customerVerificationData: null,
  paymentFlowMode: null,
  formDefinition: null,
  stepData: {},
  proposalData: null,
  documents: {},
  pincodeTermPlanAvailability: null,
};

const rootReducer = combineReducers({
  journey: journeyReducer,
});

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["journey"], // persist only journey
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.DEV,
  preloadedState: {
    journey: journeyInitialState,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export default store;